import React from "react";
import { MapPin, ArrowRight, Check } from "lucide-react";
import { hero, brand } from "../mock";

const Hero = ({ onEnquire }) => {
  return (
    <section id="hero-section" className="relative pt-28 md:pt-32 pb-16 md:pb-24 parchment overflow-hidden">
      <img src={hero.multiFlowers} alt="" className="ornament right-0 top-16 w-52 md:w-80 opacity-70" />
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10 items-center relative">
        <div className="reveal">
          <div className="flex items-center gap-2 mb-5">
            <img src={hero.locationIcon} alt="" className="w-4 h-4" />
            <span className="font-display-e text-[11px] tracking-[.24em] text-[#2a3d5c]">{hero.location}</span>
          </div>
          <h1 className="h-title text-[38px] md:text-[56px] leading-[1.05]">
            {hero.title}<br />
            <span className="italic text-[#c26a4a]">{hero.titleAccent}</span>
          </h1>

          <div className="mt-8 flex flex-wrap items-end gap-6">
            <div>
              <p className="eyebrow mb-1">{hero.priceLabel}</p>
              <p className="font-serif-e text-[38px] md:text-[46px] font-semibold text-[#2a3d5c] leading-none">{hero.price}</p>
            </div>
            <p className="text-sm text-[#6b6a63] font-medium max-w-[220px]">{hero.offerText}</p>
          </div>

          <div className="mt-8 bg-white/60 border border-[#c26a4a]/25 rounded-2xl p-5 backdrop-blur-sm">
            <p className="font-display-e text-[13px] tracking-[.22em] text-[#2a3d5c] mb-3">OFFER BENEFITS</p>
            <div className="grid grid-cols-2 gap-y-2 gap-x-4">
              {hero.offerBenefits.map((b) => (
                <div key={b} className="flex items-center gap-2 text-[13px] text-[#2b2b28]">
                  <Check size={14} className="text-[#c26a4a] shrink-0" />
                  <span className="capitalize">{b}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <button onClick={onEnquire} className="btn-gold">
              ENQUIRE NOW <ArrowRight size={14} />
            </button>
            <a href={brand.sampleFlatTour} target="_blank" rel="noreferrer" className="btn-outline-gold">
              SAMPLE FLAT TOUR <ArrowRight size={14} />
            </a>
          </div>

          <a href={brand.mapUrl} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-[13px] text-[#2a3d5c] hover:text-[#c26a4a] transition-colors">
            <MapPin size={16} className="text-[#c26a4a]" /> {brand.location}
          </a>
        </div>

        <div className="relative floaty">
          <div className="relative rounded-[24px] overflow-hidden shadow-[0_30px_60px_rgba(31,58,42,0.18)] border border-white/60">
            <img src={hero.leftImage} alt="Eternia" className="w-full h-[480px] md:h-[600px] object-cover" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#2a3d5c]/70 to-transparent p-6">
              <img src={brand.eterniaLogo} alt="Eternia" className="h-16 md:h-20 object-contain" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
